import React from 'react';
import config from '../../../../config';
import NumberFilter from '@inovua/reactdatagrid-community/NumberFilter';
import * as Yup from 'yup';
import DateFilter from '@inovua/reactdatagrid-community/DateFilter';
import Header from '../../../components/Header/Header';
import Toolbar from '../../../components/Toolbar/Toolbar';
import Table from '../../../components/Table/Table';
import NavBar from '../../../components/NavBar/NavBar';
import BoolFilter from '@inovua/reactdatagrid-community/BoolFilter';
import { Switch } from '@mui/material';
import { useTranslation } from 'react-i18next';

const ContentOwner = () => {
  const urls = {
    list: config.CONTENT_OWNER,
    create: config.CONTENT_OWNER,
    update: config.CONTENT_OWNER_WITH_ID,
    delete: config.CONTENT_OWNER_WITH_ID
  };
  const resource = 'PRODUCT';
  const { t } = useTranslation();

  const columns = [
    {
      header: t('id'),
      name: 'contentOwnerId',
      type: 'number',
      isEditable: false,
      filterEditor: NumberFilter
    },
    {
      header: t('name'),
      name: 'name',
      type: 'string',
      validationSchema: Yup.string().max(255).required('Name is required'),
      required: true,
      isEditable: true,
      defaultFlex: 1
    },
    {
      header: t('description'),
      type: 'string',
      isEditable: true,
      name: 'description'
    },
    {
      header: t('product.id'),
      id: 'productId',
      type: 'number',
      render: ({ data }) => data && data.productId,
      filterEditor: NumberFilter
    },
    {
      header: t('type'),
      name: 'productType',
      type: 'select',
      isEditable: false,
      render: ({ value }) => value && value.productTypeName
    },
    {
      header: t('is.active'),
      name: 'isActive',
      type: 'boolean',
      isEditable: true,
      filterEditor: BoolFilter,
      render: ({ value }) => <Switch disabled checked={value} />
    },
    {
      header: t('date.added'),
      name: 'dateAdded',
      type: 'date',
      filterEditor: DateFilter,
      dateFormat: 'YYYY-MM-DDTHH:mm:ss'
    },
    {
      header: t('date.modified'),
      name: 'dateModified',
      type: 'date',
      filterEditor: DateFilter,
      dateFormat: 'YYYY-MM-DDTHH:mm:ss'
    }
  ];

  return (
    <>
      <Header title={t('content.owners')} />
      <Toolbar iamResource={resource} />
      <Table
        iamResource={resource}
        uniqueId={'contentOwnerId'}
        tableId={'contentOwner'}
        columns={columns}
        urls={urls}
      />
      <NavBar />
    </>
  );
};

export default ContentOwner;
